import Http from '../../common/services/Http';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import { GpsLocatorDto } from './models/GpsLocatorDto';

class GpsLocatorsService {

    public GetAllForSelectItem() {
        return Http.get<SelectValueLabel[]>('gpslocators/get-All-for-select-item');
    }

    public getAll() {
        return Http.get<GpsLocatorDto[]>('gpslocators/all');
    }
    
}

export default new GpsLocatorsService();